import { MarginProps, styledMargin } from '@tink/core/src/components/atoms/Margins/margins';
import { styled } from '../../../core/theme/styled';

export const StyledImage = styled.img`
  width: 100%;
`;

export const StyledRoundContainer = styled.div<MarginProps & { size: string }>`
  ${styledMargin}
  width: ${(props) => props.size};
  height: ${(props) => props.size};
  background-color: ${(props) => props.theme.palette.white.main};
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.04);
  border: 1px solid ${(props) => props.theme.palette.greyBorder.main};
  border-radius: 20%;
`;
